export interface AssetSaveDialogData {
  message: string;
  subMessage: string;
}

export interface AssetSaveDialogResult {
}
